import baseAPI from '@/api/base';
import { EditAttendanceSchedule, GetAttendanceSchedule, RegisterAttendanceSchedule } from '@/dtos/attendance_schedule.dto';
import {
  DELETE_ATTENDANCE_SCHEDULE_URL,
  EDIT_ATTENDANCE_SCHEDULE_URL,
  GET_ATTENDANCE_SCHEDULE_URL,
  REGISTER_ATTENDANCE_SCHEDULE_URL,
  TOGGLE_ATTENDANCE_SCHEDULE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class AttendanceSchedule {
  static getAttendanceSchedules = async (getAttendanceSchedule: GetAttendanceSchedule): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ATTENDANCE_SCHEDULE_URL, {
      params: getAttendanceSchedule,
    });
    console.log('response', response);
    return response;
  };

  static registerAttendanceSchedule = async (
    registerAttendanceSchedule: RegisterAttendanceSchedule
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_ATTENDANCE_SCHEDULE_URL, {
      ...registerAttendanceSchedule,
    });
    console.log('response', response);
    return response;
  };

  static editAttendanceSchedule = async (editAttendanceSchedule: EditAttendanceSchedule): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_ATTENDANCE_SCHEDULE_URL, {
      ...editAttendanceSchedule,
    });
    return response;
  };

  static toggleAttendanceScheduleIsActive = async (
    editAttendanceSchedule: EditAttendanceSchedule
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ATTENDANCE_SCHEDULE_IS_ACTIVE_URL,
      {
        ...editAttendanceSchedule,
      }
    );
    return response;
  };

  static deleteAttendanceSchedule = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ATTENDANCE_SCHEDULE_URL}/${userId}`
    );
    return response;
  };
}

export default AttendanceSchedule;
